import Box from '@mui/material/Box';

import NumberSteps from '../NumberSteps';
import CreateKitStepBasicInfo from './dependencies/CreateKitStepBasicInfo';
import CreateKitStepQuantities from './dependencies/CreateKitStepQuantities';
import CreateKitStepSelectProducts from './dependencies/CreateKitStepSelectProducts';
import CreateKitStepSummary from './dependencies/CreateKitStepSummary';
import useCreateKit from './useCreateKit';

interface CreateKitProps {
  onClose: () => void;
  onProductsAdded?: () => Promise<void>;
}

const CreateKit = ({ onClose, onProductsAdded }: CreateKitProps) => {
  const hook = useCreateKit({ onClose, onProductsAdded });

  return (
    <Box sx={{ width: '100%' }}>
      <NumberSteps
        step={hook.currentStep}
        titles={['Datos del Kit', 'Selecciona productos', 'Cantidades', 'Resumen']}
      />
      {hook.currentStep === 1 && (
        <CreateKitStepBasicInfo
          step={hook.currentStep}
          setCurrentStep={hook.handleChangeStep}
          register={hook.register}
          errors={hook.errors}
          isDisabled={hook.isStepDisabled(1)}
        />
      )}
      {hook.currentStep === 2 && (
        <CreateKitStepSelectProducts
          step={hook.currentStep}
          setCurrentStep={hook.handleChangeStep}
          catalogProducts={hook.catalogProducts}
          catalogSearch={hook.catalogSearch}
          isLoadingCatalog={hook.isLoadingCatalog}
          onOpenCatalog={hook.onOpenCatalog}
          onChangeCatalogInput={hook.onChangeCatalogInput}
          selectedProducts={hook.selectedProducts}
          onChangeSelectedProducts={hook.onChangeSelectedProducts}
          isDisabled={hook.isStepDisabled(2)}
        />
      )}
      {hook.currentStep === 3 && (
        <CreateKitStepQuantities
          step={hook.currentStep}
          setCurrentStep={hook.handleChangeStep}
          fields={hook.fields}
          selectedProductsMap={hook.selectedProductsMap}
          onChangeQuantity={hook.onChangeQuantity}
          errors={hook.errors}
          watch={hook.watch}
          isDisabled={hook.isStepDisabled(3)}
        />
      )}
      {hook.currentStep === 4 && (
        <CreateKitStepSummary
          name={hook.watch('name')}
          sku={hook.watch('sku')}
          price={hook.watch('price')}
          fields={hook.fields}
          selectedProductsMap={hook.selectedProductsMap}
          watch={hook.watch}
          onSubmit={hook.handleSubmit(hook.onSubmit)}
          isCreating={hook.isCreating}
        />
      )}
    </Box>
  );
};

export default CreateKit;
